module.exports = __webpack_public_path__ + "img/gemini-ico.6a40f9b4.svg";